module.exports = __webpack_public_path__ + "img/complife-group-logo-xl.35bf5617.jpg";